module.exports = __webpack_public_path__ + "img/face64.e217a961.gif";